import type { FloorRoom, Order } from "../../api/types";
import { t } from "../../i18n";
import { tablesByRoom } from "./waiter";

interface Props {
  from: string;
  floor: readonly FloorRoom[];
  openTables: ReadonlyMap<string, Order>;
  /** Tables with lines not sent yet: they are not free either. */
  withDraft: ReadonlySet<string>;
  busy: boolean;
  onBack: () => void;
  onMove: (to: string) => void;
}

/**
 * "Tafel X verplaatsen naar…" (prototype ob move, besluiten 28/09: only free tables): everything goes
 * along; the kitchen gets a ticket VERPLAATST.
 */
export function MoveView({ from, floor, openTables, withDraft, busy, onBack, onMove }: Props) {
  const text = t.tafoApp.waiter;
  const rooms = tablesByRoom(floor)
    .map(({ room, tables }) => ({
      room,
      free: tables.filter((table) => table !== from && !openTables.has(table) && !withDraft.has(table)),
    }))
    .filter(({ free }) => free.length > 0);
  return (
    <>
      <button type="button" className="linkbtn" onClick={onBack}>
        {text.backTable(from)}
      </button>
      <h3>{text.moveTitle(from)}</h3>
      <div className="ob-move">
        {rooms.length === 0 && <p className="proto">{text.noFreeTable}</p>}
        {rooms.map(({ room, free }) => (
          <section key={room.id} aria-label={room.name}>
            <div className="zone">{room.name}</div>
            <div className="tables">
              {free.map((table) => (
                <button
                  key={table}
                  type="button"
                  className="tbl"
                  disabled={busy}
                  aria-label={text.table(table)}
                  onClick={() => {
                    onMove(table);
                  }}
                >
                  {table}
                  <small>{text.free}</small>
                </button>
              ))}
            </div>
          </section>
        ))}
      </div>
      <p className="proto">{text.moveNote}</p>
    </>
  );
}
